import { Directive, ElementRef, Input, AfterViewInit, HostBinding, NgZone } from '@angular/core';

declare var window: any;

@Directive({
  selector: '[appReveal]'
})
export class RevealDirective implements AfterViewInit {

  private element: any;

  @Input() distance = '20px';
  @Input() origin: 'top' | 'bottom' | 'left' | 'right' = 'bottom';
  @Input() threshold = 0.1;
  @Input() rootMargin = '0px';

  @HostBinding('class.reveal') reveal = true;
  @HostBinding('class.revealed') revealed = false;

  @HostBinding('style.--reveal-x')
  get revealX() {
    return this.origin === 'left' ? '-' + this.distance
      : this.origin === 'right' ? this.distance
      : '0px';
  }

  @HostBinding('style.--reveal-y')
  get revealY() {
    return this.origin === 'top' ? '-' + this.distance
      : this.origin === 'bottom' ? this.distance
      : '0px';
  }

  constructor(el: ElementRef, private ngZone: NgZone) {
    this.element = el.nativeElement;
  }

  ngAfterViewInit() {
    if (typeof window === 'undefined') {
      return;
    }

    if (typeof IntersectionObserver === 'undefined') {
      this.revealed = true;
      return;
    }

    // IntersectionObserver callbacks aren't patched into Angular's zone by
    // default (unlike the zone.js browser bundle's addEventListener/timer
    // patches), so re-enter the zone manually to guarantee change detection
    // picks up the class change.
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.ngZone.run(() => {
            this.revealed = true;
          });
          observer.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: this.rootMargin,
      threshold: this.threshold,
    });

    observer.observe(this.element);
  }

}
